import React from 'react';
import { Modal } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import './ProjectCreatedModal.css';

export const ProjectCreatedModal = ({
  isOpen,
  onClose,
  onConfirm,
  isError = false,
  title,
  message,
  confirmButtonText,
  errorResponse,
  secondaryButtonText,
  onSecondaryAction,
}) => {
  const { t } = useTranslation();



  const isDeadlineError = errorResponse?.status === 400;
  const isProjectNameError = errorResponse?.status === 406;

  const defaultTitle = isError
    ? (isDeadlineError ? '⚠️ ' + t('Deadline dépassée') : t('Nom du projet existant'))
    : t('Projet créé');

  const defaultMessage = isError
    ? (
      isDeadlineError ? (
        <>
          La deadline du rédacteur dépasse la deadline globale du projet.
          <br />
          Veuillez ajuster la date pour continuer.
        </>
      ) : (
        <>
          {t('Un projet avec ce nom existe déjà dans votre espace.')}
          <br />
          {t('Merci de choisir un nom différent pour continuer.')}
        </>
      )
    )
    : (
      <>
        {t('Votre projet a bien été créé.')}
        <br />
        {t('Vous pouvez commencer à travailler dessus dès maintenant.')}
      </>
    );
  const defaultConfirmText = isError ? t('Fermer') : t('Voir le projet');

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      className="project-created-modal"
      backdrop={true}
      keyboard={true}
      centered
    >
      <div className="project-created-modal-content">
        <div className="project-created-modal-header">
          <h2 className="project-created-modal-title">{title || defaultTitle}</h2>
          <button
            className="project-created-modal-close-button"
            onClick={onClose}
            aria-label={t('Fermer')}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4L4 12M4 4L12 12" stroke="#666666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
        <div className="project-created-modal-body">
          <p className="project-created-modal-message">
            {message || defaultMessage}
          </p>
        </div>
        <div className="project-created-modal-footer">
          {secondaryButtonText && (
            <button
              className="project-created-modal-secondary-button"
              onClick={onSecondaryAction || onClose}
            >
              {secondaryButtonText}
            </button>
          )}
          <button
            className="project-created-modal-confirm-button"
            onClick={isError ? onClose : onConfirm}
          >
            {confirmButtonText || defaultConfirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ProjectCreatedModal;
